import type { SpectralManorResult } from "../worker/src/standalone-leaderboard";

const queueKey = "party-stack-standalone-results-v1";
let pending = false;
function readQueue(): SpectralManorResult[] {
  try { const value = JSON.parse(localStorage.getItem(queueKey) || "[]"); return Array.isArray(value) ? value : []; } catch { return []; }
}
export async function flushStandaloneResults(api: string) {
  if (pending) return;
  pending = true;
  try {
    for (const result of readQueue()) {
      let response: Response;
      try { response = await fetch(`${api}/leaderboard/standalone`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(result) }); }
      catch { break; }
      if (!response.ok) break;
      localStorage.setItem(queueKey, JSON.stringify(readQueue().filter((item) => item.id !== result.id)));
    }
  } finally { pending = false; }
}
export async function saveStandaloneResult(api: string, result: SpectralManorResult) {
  const queue = readQueue(); if (!queue.some((item) => item.id === result.id)) queue.push(result);
  localStorage.setItem(queueKey, JSON.stringify(queue));
  await flushStandaloneResults(api);
  return !readQueue().some((item) => item.id === result.id);
}
